//MULTISELECT SCRIPT START

Drupal.behaviors.myBehavior = {
    attach: function (context, settings) {
        setTimeout(function () {
            var multiselectLi = $('.multiselect-native-select .multiselect-container li, .multiselect-native-select .form-select option');
            multiselectLi.each(function () {
                if ($(this).attr('value') == '_none') {
                    $(this).remove();
                }
                if ($(this).find('input').val() == '_none') {
                    $(this).removeClass('active').remove();
                }
            });
        }, 0);
        $('.form-item-field-resource-goals-target-id .form-select,.form-item-field-sustainable-development-go-target-id .form-select').multiselect({
            nonSelectedText: 'Select SDG Goals',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-new-urban-agenda-principle-target-id .form-select').multiselect({
            nonSelectedText: 'Select New Urban Agenda',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-resource-themes-target-id  .form-select,.form-item-field-themes-target-id .form-select').multiselect({
            nonSelectedText: 'Select Themes',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-type-of-organization-target-id  .form-select').multiselect({
            nonSelectedText: 'Select Type of Organization',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-resource-type-target-id .form-select').multiselect({
            nonSelectedText: 'Select Resource Type',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-sub-type-target-id .form-select').multiselect({
            nonSelectedText: 'Select Sub Type',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.filter-dropdown .form-item-field-regions-target-id .form-select, .filter-dropdown .form-item-field-region-target-id .form-select').multiselect({
            nonSelectedText: 'Select Region',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-resource-location-country .form-select,.form-item-field-bp-location-country .form-select').multiselect({
            nonSelectedText: 'Select Resource Location',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        // $('.form-item-field-resource-city-target-id .form-select').multiselect({
        //     nonSelectedText: 'Select City',
        //     enableFiltering: true,
        //     enableCaseInsensitiveFiltering: true,
        //     enableFullValueFiltering: false,
        //     includeSelectAllOption: true,
        //     maxHeight: 300,
        //     buttonWidth: '100%',
        // });
        // $('.form-item-field-year-of-publication-value .form-select').multiselect({
        //     nonSelectedText: 'From',
        //     enableFiltering: false,
        //     enableCaseInsensitiveFiltering: false,
        //     enableFullValueFiltering: false,
        //     includeSelectAllOption: false,
        //     maxHeight: 250,
        //     buttonWidth: '100%',
        // });
        // $('.form-item-field-knowledge-completion-year-value .form-select').multiselect({
        //     nonSelectedText: 'To',
        //     enableFiltering: false,
        //     enableCaseInsensitiveFiltering: false,
        //     enableFullValueFiltering: false,
        //     includeSelectAllOption: false,
        //     maxHeight: 250,
        //     buttonWidth: '100%',
        // });
        $('.form-item-field-awards-target-id .form-select').multiselect({
            nonSelectedText: 'Select Awards',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-awards-target-id .form-select').multiselect({
            nonSelectedText: 'Select Awards',
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 300,
            buttonWidth: '100%',
        });
        $('.form-item-field-start-year-value .form-item-field-start-year-af-value .form-select').multiselect({
            nonSelectedText: 'From',
            enableFiltering: false,
            enableCaseInsensitiveFiltering: false,
            enableFullValueFiltering: false,
            includeSelectAllOption: false,
            maxHeight: 250,
            buttonWidth: '100%',
        });
        $('.form-item-field-completion-year-value .form-item-field-completion-year-af-value .form-select').multiselect({
            nonSelectedText: 'To',
            enableFiltering: false,
            enableCaseInsensitiveFiltering: false,
            enableFullValueFiltering: false,
            includeSelectAllOption: false,
            maxHeight: 250,
            buttonWidth: '100%',
        });

        setTimeout(function () {
            $('.filter-grid-wrap').find('.form--inline').addClass('row');
            $('.filter-grid-wrap').find('.form-type-select,.form-item-keys,.form-item-created-1,.form-item-created').addClass('col-lg-4 col-xl-3 col-sm-6 col-md-6 col-12');
            $('.filter-grid-wrap').find('.form-actions .form-submit').first().addClass('btn-lg');
            $('.filter-grid-wrap').find('.form-actions .form-submit').last().addClass('btn-lg btn-border-custom');
        }, 500);
        $('.multiselect-filter-wrap .form-select[multiple="multiple"],.filter-dropdown .form-select[multiple="multiple"]').multiselect({
            enableFiltering: true,
            enableCaseInsensitiveFiltering: true,
            enableFullValueFiltering: false,
            includeSelectAllOption: true,
            maxHeight: 340,
            buttonWidth: '100%',
        });
    }
};

$(document).ready(function () {
    setTimeout(function () {
        $('.node-ms-upload-reports-form .field--name-field-sustainable-development-go').find('input[value=51]').closest("li").css({
            'opacity': '0.6',
            'pointer-events': 'none'
        });
    }, 500);
    $('.multiselect-control,.form-select[multiple="multiple"]').multiselect({
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        enableFullValueFiltering: false,
        includeSelectAllOption: true,
        maxHeight: 340,
        buttonWidth: '100%',
    });
    $('.multiselect-multilevel-control').multiselect({
        enableFiltering: true,
        enableCaseInsensitiveFiltering: true,
        enableFullValueFiltering: false,
        includeSelectAllOption: true,
        maxHeight: 340,
        buttonWidth: '100%',
        enableClickableOptGroups: true,
        enableCollapsibleOptGroups: true,
        //selectAllText: 'Sustainable Urban Development'
    });
    $('.node-ms-upload-reports-form .field--name-field-sustainable-development-go .form-type-select .form-select').multiselect('select', '51');
});
//MULTISELECT SCRIPT END
